/**
 * LayoutsPanel component
 * @constructor editor.mediatabs.LayoutsPanel
 * @param {object} dom DOM
 */
fx.ns("desktop.poster", class LayoutsPanel extends fx.components.Box
{
    
    constructor(data)
	{
		super(data);
		
        if (!data.creation.useMedias)
		    this.listenUpdates(data.creation);
		
	}
	
	get currentArea()
	{
		return this._currentArea;
	}

	set currentArea(val)
	{
		this._currentArea = val;

        // TODO : check if needed
		if (this.layoutFilter)
			this.layoutFilter.area = this._currentArea;

	}


    get filterChoices()
	{
		if (!this._filterChoices)
        {
            if (!this.data.createdFromLayout)
                this._filterChoices = [	{label:fx.text("Classique"), data:"classical"}, {label:fx.text("Thématique"), data:"recommended"}];
            else
                this._filterChoices = [	{label:fx.text("Thématique"), data:"recommended"},  {label:fx.text("Classique"), data:"classical"}];
        }
						
		return this._filterChoices;
	}

	set filterChoices(choices)
	{
		this._filterChoices = choices;
		if(this.numberPhotoSelect)
			this._selectTab(this._filterChoices[0].data);
	}

	create()
	{
		super.create();

		//--------------------- layouts ---------------------//

        if (this.data.creation.useMedias)
        {
            this.layoutsGrid = new fx.components.VerticalGridDynamic( { className : "layoutGrid",
                                                                        data : this.data.layouts,
                                                                        maxElementsPerRow : 1,
                                                                        maxRowHeight : 230,
                                                                        newChildEffect : "fade",
                                                                        renderers : {ThemeLayout : shared.renderers.LayoutRenderer} 
                                                                    } );

            
            this.addChild(this.layoutsGrid, {height:"fill", width:"100%", top : 25});
        }
        else
        {
            this.layoutFilter = new filters.LayoutPosterFilter( this.filterChoices.getItemAt(0).data );
                                                                    
            this.addChild( new fx.components.Text({className : "coverTitle", text : fx.text("Modèles pour votre affiche")}), {width : "100%",height : 20, top : 20, left : 0});

            this.coverChoicesSelect = new fx.components.TabBarHorizontal( {tabs : this.filterChoices, style : "underline"} );
            this.addChild(this.coverChoicesSelect, {width:"100%", height: 40, top : 55, left: 5});

            this.layoutsGrid = new fx.components.VerticalGridDynamic( { className : "layoutGrid",
                                                                        data : this.data.layouts,
                                                                        filter : this.layoutFilter,
                                                                        maxElementsPerRow : 2,
                                                                        maxRowHeight : 200,
                                                                        newChildEffect : "fade",
                                                                        renderers : {ThemeLayout : shared.renderers.LayoutRenderer} 
                                                                    } );

  
            this.addChild(this.layoutsGrid, {height:"fill", width:"100%", top : 115});
        }
		
	}

    onReady()
    {
        super.onReady();

        if (!this.data.creation.useMedias)
            this.on("tabchanged", this.onCoverChoiceChanged, this.coverChoicesSelect);
    }
	/****** Events ******/

    onCoverChoiceChanged()
    {
        if (!this.coverChoicesSelect.selectedItem) return;

		this.layoutsGrid.scrollTop();

		switch(this.coverChoicesSelect.selectedItem.data)
		{
			case "recommended":
				this.layoutFilter.search = "recommended";
				break;
			case "classical":
				this.layoutFilter.search = "classical";
				break;

		}

	}



	/****** Functions ******/

});
